export const ChatDateComp = (props:{time: string, date: string})=>{

    return(
        <div className='flex-column' style={{fontSize: 12, marginRight: 5, alignItems: 'flex-end'}} >
            <p>{props.time}</p>
            <p>{props.date}</p>
        </div>
    )
}